module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/ltv/icon_case01-be51290796c71bc6120035a6bfebb5a1.svg";